import { useState } from 'react';
import filterNames from '../../shared/constants/filterNames';
import uniq from 'lodash/uniq';
import { getStatusColor } from '../../shared/constants/statuses';
import { Anomaly } from './types';
import { useTranslation } from 'react-i18next';
import {FilterOption, Filters} from "../TableFilters/types";

const initialFilters: Filters = {
  criticality: { [filterNames.all]: true },
};

/**
 * filters - object with currently active filters
 * filterOptions - all possible values that could be set to filter object
 */

const useAnomalyFilters = (anomalies: Array<Anomaly>) => {
  const { t } = useTranslation();

  const [filters, updateFilters] = useState(initialFilters);

  const filterOptions: Array<FilterOption> = [
    {
      name: 'Issue Criticality',
      key: 'criticality',
      items: [
        { name: t('Table.All'), key: filterNames.all },
        ...uniq(anomalies.map(el => el.criticality)).map(filterName => ({
          key: filterName,
          name: getStatusColor(filterName),
        })),
      ],
    },
  ];

  return { filters, filterOptions, updateFilters };
};

export default useAnomalyFilters;
